import { render, staticRenderFns } from "./ProductosInmobiliaria.vue?vue&type=template&id=20704ec8&scoped=true&"
import script from "./ProductosInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./ProductosInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./ProductosInmobiliaria.vue?vue&type=style&index=0&id=20704ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20704ec8",
  null
  
)

export default component.exports